import React from 'react';
import { getTemplate } from 'TRANSLATION';
const Content = getTemplate('hint/utilityBill');

export default function PEPHint() {
  return <Content />;
}
